import { Wifi, WifiOff, Signal, SignalLow, SignalMedium, SignalHigh } from 'lucide-react';
import { useConnectionMode } from '@/connection/SimpleConnectionProvider';
import { useOfflineStatus } from '@/hooks/useOfflineStatus';

export const LiteModeBadge = () => {
  const mode = useConnectionMode();
  const isOffline = useOfflineStatus();

  const getConnectionStatus = () => {
    if (isOffline || mode === 'offline') {
      return {
        icon: WifiOff,
        text: 'Offline',
        className: 'bg-red-100 border-red-300 text-red-800',
        networkType: null
      };
    }

    // Get actual network info
    const connection = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
    const effectiveType = connection?.effectiveType;
    const networkTypeText = effectiveType ? `${effectiveType.toUpperCase()} network detected` : null;
    
    // Show mode-based status with network context
    switch (mode) {
      case 'lite':
        // Only show network type in badge for actual slow connections (2G/3G)
        const isSlowConnection = effectiveType === '2g' || effectiveType === 'slow-2g' || effectiveType === '3g';
        const networkContext = isSlowConnection ? ` (${effectiveType.toUpperCase()})` : '';
        return {
          icon: SignalLow,
          text: `Lite Mode${networkContext}`,
          className: '',
          style: {
            backgroundColor: '#E0F8E9',
            borderColor: '#137B3F',
            color: '#137B3F'
          },
          networkType: networkTypeText
        };
      case 'balanced':
        return {
          icon: SignalMedium,
          text: 'Balanced Mode',
          className: 'bg-blue-100 border-blue-300 text-blue-800',
          networkType: networkTypeText
        };
      case 'full':
        return {
          icon: SignalHigh,
          text: 'Full Quality',
          className: 'bg-green-100 border-green-300 text-green-800',
          networkType: networkTypeText
        };
      default:
        return {
          icon: Signal,
          text: 'Auto Mode',
          className: 'bg-gray-100 border-gray-300 text-gray-800',
          networkType: networkTypeText
        };
    }
  };

  const status = getConnectionStatus();
  const IconComponent = status.icon;

  return (
    <div className="flex flex-col items-start gap-1">
      <div 
        className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border ${status.className}`}
        style={status.style}
      >
        <IconComponent className="h-3 w-3" />
        <span>{status.text}</span>
      </div>
      {status.networkType && (
        <span className="text-[10px] ml-1" style={{ color: '#000000' }}>
          {status.networkType}
        </span>
      )}
    </div>
  );
};